import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { clientReducer } from "features/client/client.reducer";
import { authReducer } from "features/auth/auth.reducer";
import { configReducer } from "features/config/config.reducer";
import { projectReducer } from "features/project/project.reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["client", "config", "auth"],
};

const rootReducer = combineReducers({
  config: configReducer,
  client: clientReducer,
  auth: authReducer,
  project: projectReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/PURGE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/REGISTER",
        ],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
